import React from "react";
import { GridCell, GridContainer } from "../Grid";

export const HeaderBasic: React.FC = () => {

    return (
        <header className="header">
            <GridContainer hasMarginX>
                <GridCell>
                    <span>FIMC-VI <span className="media-library">Portal</span></span>
                </GridCell>
            </GridContainer>
        </header>
    );
};
